"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MappersLegacyDefinition = void 0;
const helpers_1 = require("@wix/services-manager/helpers");
exports.MappersLegacyDefinition = (0, helpers_1.defineService)('viewer-core/mappers-legacy');
//# sourceMappingURL=index.js.map